<section
  [ngStyle]="{ 'background-image': 'url(\'/assets/images/HeroCountryFlags/' + (country || 'banner') + '.jpg\')' }">
  <div class="container">
    <h1 [ngClass]="{country:  (country || 'banner') !== 'banner'}">{{ 'component.hero.send_money' | translate }}
      {{country}}</h1>
  </div>
</section>